import { defineStore } from 'pinia'
import { themeConfig, themePreset } from '@/themeConfig'

/**
 * 테마 상태 관리 (Pinia)
 * - Vuex themeConfig 대체용
 */
export const useThemeStore = defineStore('theme', {
  state: () => ({
    /** @type {import('@/types/theme').ThemeMode} */
    themeMode: { ...themeConfig },
    /** @type {import('@/types/theme').VuetifyPreset} */
    vuetifyPreset: { ...themePreset },
  }),
  actions: {
    /**
     * @param {boolean} isDark
     */
    changeThemeDarkMode(isDark) {
      this.themeMode.isDark = isDark
    },
    /**
     * @param {string} layout
     */
    changeThemeLayout(layout) {
      this.themeMode.layout = layout
    },
    changeThemeRtl() {
      this.themeMode.rtl = !this.themeMode.rtl
    },
    /**
     * @param {boolean} payload
     */
    changeThemeLoadingState(payload) {
      this.themeMode.isLoading = payload
    },
    changeVerticalSidebarDrawer() {
      this.themeMode.verticalSidebarDrawer = !this.themeMode.verticalSidebarDrawer
    },
    changeVerticalSaasSidebarDrawer() {
      this.themeMode.verticalSaasSidebarDrawer = !this.themeMode.verticalSaasSidebarDrawer
    },
    /**
     * @param {string} color
     */
    changeVerticalSidebarDrawerColor(color) {
      this.themeMode.verticalSidebarDrawerColor = color
    },
    /**
     * @param {string} color
     */
    changeAppBarColor(color) {
      this.themeMode.appBarColor = color
    },
    changeCompactVerticalSidebarDrawer() {
      this.themeMode.verticalCompactSidebarDrawer = !this.themeMode.verticalCompactSidebarDrawer
    },
    changeVerticalSidebarMini() {
      this.themeMode.verticalSidebarMini = !this.themeMode.verticalSidebarMini
    },
  },
})

export default useThemeStore
